const releasesIT = {
    "view": {
        "table": {
            "title": "La tua lista di pubblicazioni",
            "column": {
                "name": "Nome",
                "artist": "Artista",
                "catalogue_number": "Num. Cat.",
                "release_date": "Data di pubblicazione",
                "status": "Stato",
                "store_urls": "URL dei negozi",
                "qc": "QC",
                "pre_scan": "Pre-Scan",
                "alert": "Avviso",
                "flagged": "Contrassegnato",
                "action": "Azione"
            },
            "label": {
                "status_ready": "Pronto",
                "status_approval": "In coda per l'invio",
                "status_takedown_request": "Richiesta di rimozione",
                "status_taken_down": "Rimosso",
                "status_distributed": "Distribuito",
                "status_locked": "In corso - Bloccato",
                "status_delivering": "In consegna",
                "status_unlocked": "Per favore modifica",
                "status_offline": "Offline",
                "status_re_delivery-delivery": "Riconsegna",
                "status_re_delivery-editing": "Modifica riconsegna",
                "status_unknown": "Stato sconosciuto"
            },
            "button": {
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "dropdown": {
                "item": {
                    "action": "Azione",
                    "distribute": "Distribuisci",
                    "viewRelease": "Visualizza pubblicazione",
                    "editReleaseMetadata": "Modifica i metadati della pubblicazione",
                    "editTracks": "Modifica tracce",
                    "takedown": "Rimuovi",
                    "submitEditing": "Invia modifiche",
                    "deliveredList": "Lista consegnata",
                    "copyEanUpc": "Copia EAN/UPC"
                },
                "message": {
                    "submitInformationTooltip": "Non hai ancora fornito tutte le informazioni necessarie, quindi non puoi distribuire le pubblicazioni. Per farlo, invia gentilmente le tue informazioni.",
                    "submitMetadataTooltip": "Si prega di inviare i metadati per tutte le tracce per distribuire la pubblicazione.",
                    "submitEditingMetadataTooltip": "Si prega di inviare i metadati per tutte le tracce, per inviare le modifiche.",
                    "submitEditingTokenRequiredTooltip": "È richiesto almeno 1 token per inviare le modifiche per la riconsegna. <2>Ordina token</2>.",
                    "blacklistedArtistTooltip": "Questa pubblicazione non può essere distribuita perché contiene una o più tracce da un artista blacklisted. Per favore contatta il nostro team di supporto per ulteriori informazioni.",
                    "distributionDisabledPreScanInProgress": "Si prega di attendere che il pre-scan sia completato prima di distribuire la pubblicazione.",
                    "distributionDisabledPreScanNotDone": "Si prega di eseguire il pre-scan prima di distribuire la pubblicazione.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Si prega di inviare la dichiarazione del pre-scan prima di distribuire la pubblicazione.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "Sei davvero sicuro di voler modificare i metadati?",
                        "description": {
                            "point1": "<strong>Questo cambierà i tuoi metadati e potrebbe influire sulla pubblicazione.</strong>",
                            "point2": "Procedi solo se sei completamente sicuro.",
                            "point3": "<strong>PER FAVORE NON</strong> modificare i metadati solo per testare ed esplorare."
                        },
                        "button": {
                            "cancel": "Annulla",
                            "confirm": "Ho capito"
                        }
                    },
                    "distribute": {
                        "header": "Sei sicuro che tutte le informazioni inserite siano valide e rappresentino completamente questa pubblicazione?",
                        "description": {
                            "point1": "Dopo questa azione, la tua pubblicazione verrà controllata e se le informazioni sono corrette verrà distribuita nelle date ufficiali ed esclusive di distribuzione.",
                            "point2": "Confermando e accettando questo modulo, accetti pienamente e ti conformi ai <1>Termini di Distribuzione</1>, <3>Termini di Utilizzo</3> e <5>Politica sulla Privacy</5>.",
                            "point3": "Confermando e accettando questo modulo, confermi indiscutibilmente che il contenuto della pubblicazione inviato con i relativi asset, file audio e metadati, appartiene esclusivamente a te o è completamente concesso in licenza alla tua etichetta.",
                            "point4": "Con la presente accetti pienamente di essere l'unico responsabile per qualsiasi informazione fuorviante, utilizzo non autorizzato, attività illegale o qualsiasi tipo di controversia.",
                            "flaggedTracksTerms": {
                                "header": "Termini delle Tracce Contrassegnate",
                                "point1": "Nota: <strong>'{{releaseName}}'</strong> contiene una o più tracce contrassegnate. Si applica una tariffa di <strong>15 €</strong> per traccia contrassegnata per consegnare la pubblicazione a <strong>Spotify</strong>. Poiché hai scelto di non pagare questa tariffa in questo momento, la pubblicazione non verrà consegnata a Spotify. Confermando e accettando questo modulo, riconosci e accetti questi termini.",
                                "point2": "In futuro, se scegli di consegnare la pubblicazione a <strong>Spotify</strong>, puoi andare alla sezione Contrassegnati nella tabella delle pubblicazioni e seguire le istruzioni di pagamento."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Dichiarazione di Streaming Artificiale",
                                "point1": "<strong>1.</strong> Comprendo e accetto pienamente di non impegnarmi in alcuna forma di streaming artificiale, incluso l'uso di bot, farm di streaming o qualsiasi metodo che manipoli le metriche DSP.",
                                "point2": "<strong>2.</strong> Non pagherò né offrirò pagamenti per posizionamenti in playlist, né lavorerò con terze parti che promettono posizionamenti garantiti — comprendo che questo è considerato frode e truffa.",
                                "point3": "<strong>3.</strong> Riconosco che tali azioni possono comportare la risoluzione immediata, la perdita di royalties, reclami legali, penali contrattuali e tariffe, e la segnalazione ai DSP e alle autorità.",
                                "point4": "<strong>4.</strong> Garantisco inoltre di informare ed educare qualsiasi artista o cliente con cui lavoro su queste regole e di assicurarmi che si conformino.",
                                "point5": "<strong>5.</strong> Comprendo che se mi impegno in streaming artificiale, i miei dati KYC, inclusi il mio nome completo, indirizzo, carta d'identità e altre informazioni personali, possono essere condivisi con i dipartimenti legali dei DSP, come quelli di Spotify, Apple Music e altri.",
                                "point6": "<strong>6.</strong> Accetto la piena responsabilità legale per eventuali violazioni.",
                                "acknowledgment": "Con la presente riconosco e accetto di rispettare i termini di Streaming Artificiale sopra indicati e accetto la piena responsabilità legale per eventuali violazioni."
                            }
                        },
                        "button": {
                            "cancel": "Annulla",
                            "confirm": "Conferma e Accetta"
                        }
                    },
                    "takedown": {
                        "header": "Sei sicuro di voler rimuovere questa pubblicazione da tutti i negozi?",
                        "description": {
                            "point1": "Questa azione è irreversibile.",
                            "point2": "Rimuovendo questa pubblicazione, ti conformi ai <1>Termini di Distribuzione</1>, <3>Termini di Utilizzo</3> e <5>Politica sulla Privacy</5>."
                        },
                        "button": {
                            "cancel": "Annulla",
                            "confirm": "Conferma e Accetta"
                        }
                    },
                    "finishEditing": {
                        "header": "Sei sicuro che tutte le informazioni inserite siano valide e rappresentino completamente questa pubblicazione?",
                        "description": {
                            "point1": "Dopo questa azione, la tua pubblicazione verrà controllata e se le informazioni sono corrette verrà ridistribuita ai partner DSP. <strong>NOTA, solo i METADATI verranno inviati ai DSP, contenuti come IMMAGINI e file AUDIO non possono essere aggiornati in questo modo.</strong>",
                            "point2": "Confermando e accettando questo modulo, accetti pienamente e ti conformi ai <1>Termini di Utilizzo</1> e ai Termini del nostro Accordo di Distribuzione Esclusiva.",
                            "point3": "Confermando e accettando questo modulo, accetti pienamente e ti conformi alla <1>Politica sulla Privacy</1>.",
                            "point4": "Confermando e accettando questo modulo, confermi indiscutibilmente che il contenuto della pubblicazione inviato con i relativi asset, file audio e metadati, appartiene esclusivamente a te o è completamente concesso in licenza alla tua etichetta.",
                            "point5": "Con la presente accetti pienamente di essere l'unico responsabile per qualsiasi informazione fuorviante, utilizzo non autorizzato, attività illegale o qualsiasi tipo di controversia."
                        },
                        "button": {
                            "cancel": "Annulla",
                            "confirm": "Conferma e Accetta"
                        }
                    }
                }
            },
            "message": {
                "success": "Pubblicazione aggiornata!",
                "declaration_success": "Dichiarazione inviata per la revisione dell'amministratore.",
                "declaration_error": "Qualcosa è andato storto durante l'invio della dichiarazione, riprova più tardi.",
                "pre_scan_declaration_success": "Dichiarazione del pre-scan inviata con successo.",
                "pre_scan_declaration_error": "Qualcosa è andato storto durante l'invio della dichiarazione del pre-scan, riprova più tardi.",
                "pre_scan_success": "Pubblicazione inviata con successo per il scan.",
                "pre_scan_error": "Qualcosa è andato storto durante lo scan della pubblicazione, riprova più tardi.",
                "linkCopied": "Link copiato negli appunti!"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "Hai esaurito la tua quota di distribuzione delle tracce. Per caricare più tracce, aggiorna il tuo account o contatta il nostro team di supporto.",
            "subscriptionUpgrade": "Il tuo piano di abbonamento attuale non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni.",
            "subscriptionUpgradeReleaseTransfer": "Il tuo piano di abbonamento attuale non supporta la funzione di trasferimento delle pubblicazioni. Se stai trasferendo un catalogo più ampio o desideri trasferire più cataloghi di etichette discografiche a Music Link con pochi clic, per favore <1>aggiorna</1> il tuo piano di abbonamento.",
            "noAccessReleaseTransfer": "Attualmente, non hai il permesso di utilizzare la funzione di trasferimento delle pubblicazioni. Se stai trasferendo un catalogo più ampio o desideri trasferire più cataloghi di etichette discografiche a Music Link con pochi clic, non esitare a contattare il nostro team di supporto.",
            "accountBlacklisted": "Il tuo account è stato blacklisted dopo la revisione, poiché abbiamo trovato che le informazioni associate con il tuo account sono collegate a uno degli utenti internazionalmente blacklisted nel nostro sistema. Di conseguenza, abbiamo disabilitato la funzione di distribuzione per il tuo account.",
        }
    },
    "add": {
        "title": "Aggiungi Nuova Pubblicazione",
        "form": {
            "label": {
                "required": "Obbligatorio",
                "name": "Nome della Pubblicazione",
                "version": "Versione della Pubblicazione",
                "subuser": "Sotto-Utente",
                "label": "Etichetta",
                "copyright": "Copyright ©",
                "copyright_year": "Anno Copyright ©",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Anno Copyright ℗",
                "genre": "Genere",
                "subgenre": "Sotto-Genere",
                "catalog_number": "Numero di Catalogo",
                "artwork": "Copertina",
                "artwork_alt": "La tua copertina",
                "new_release": "È una nuova pubblicazione?",
                "original_release_date": "Data di pubblicazione originale",
                "official_release_date": "Data di pubblicazione ufficiale",
                "backcatalog": "Catalogo precedente",
                "assisted_dates": "Date assistite",
                "exclusive_store_release_date": "Data di pubblicazione esclusiva nei negozi",
                "additional_metadata": "Metadati aggiuntivi",
                "release_description": "Descrizione della Pubblicazione",
                "release_language": "Lingua del Nome della Pubblicazione",
                "auto_detect_language": "Rilevamento automatico (Lingua)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Genera automaticamente (ean)",
                "territories": "Territori",
                "countries": "Paesi",
                "youtube_declaration_header": "DICHIARAZIONE DI CONTENT ID DI YOUTUBE",
                "youtube_declaration_intro": "Per aderire al Content ID di YouTube per questa pubblicazione, devi assicurarti di soddisfare TUTTI i seguenti requisiti:",
                "youtube_declaration_certify": "Io, <strong>{{firstName}} {{lastName}}</strong>, sotto pena di spergiuro, certifico che le informazioni precedenti sono vere e corrette.",
                "youtube_declaration_point1": "Ho diritti sufficienti sul materiale.",
                "youtube_declaration_point2": "Tutti i contenuti di riferimento sono sufficientemente distintivi.",
                "youtube_declaration_point3": "Ho riferimenti individuali per ogni pezzo di proprietà intellettuale.",
                "youtube_declaration_point4": "Il contenuto consegnato <strong>non</strong> è nessuno dei seguenti: dominio pubblico, contenuto con licenza non esclusiva, clip da altre fonti utilizzate secondo i principi del fair use, filmati di gioco (da parte di editori diversi dal gioco), registrazioni karaoke, rimasterizzazioni senza permesso, registrazioni simili, contenuti doppiati, accelerazioni/rallentamenti, effetti sonori, basi sonore, mix DJ continui, mashup, liste di conto alla rovescia o qualsiasi altro contenuto proibito o non idoneo nominato nelle Linee Guida del Content ID di YouTube elencate di seguito.",
                "youtube_declaration_account": "Comprendo che il mio account potrebbe essere disattivato e terminato in caso di violazioni. Inoltre, comprendo pienamente che potrei essere responsabile di eventuali commissioni, danni, spese legali o qualsiasi altra spesa che possa accumularsi.",
                "youtube_declaration_guidelines": "Secondo le <1><strong>Linee Guida del Content ID di YouTube</strong></1>, il contenuto inviato tramite questa pubblicazione è completamente idoneo per il Content ID di YouTube.",
                "youtube_content_id_eligible": "Confermo che il mio contenuto è idoneo per il <strong>Content ID di YouTube</strong>",
                "youtube_content_id_not_eligible": "Il mio contenuto non è idoneo per il <strong>Content ID di YouTube</strong>",
                "immersive_audio": "Questa pubblicazione ha audio immersivo"
            },
            "placeholder": {
                "version": "Lascia vuoto se non sei sicuro o se questa è una pubblicazione regolare",
                "select_date": "Seleziona data...",
                "copyright": "Di solito il nome della tua etichetta",
                "copyright_publisher": "Di solito il nome della tua etichetta",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "label": "Seleziona Etichetta...",
                "subuser": "Seleziona Sotto-utente...",
                "genre": "Seleziona Genere...",
                "subgenre": "Seleziona Sotto-Genere...",
                "ean": "Lascia vuoto se non sei sicuro!",
                "release_description": "Qualche parola sulla tua pubblicazione. Nessun link e indirizzi e-mail per favore. Massimo 600 caratteri"
            },
            "help_text": {
                "name": "Per favore non usare aggiunte al nome della pubblicazione come LP e EP.",
                "version": "Alcune pubblicazioni vengono rilasciate in più di una versione, in tal caso inserisci il nome della versione. Se la tua pubblicazione è originale/standard ignora questo campo.",
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una pubblicazione per uno dei tuoi Sotto-utenti altrimenti lascia non selezionato.",
                "label": "Nota: Seleziona la tua Etichetta dal menu a tendina se esiste già nel sistema, altrimenti crea la tua Etichetta cliccando <1>qui</1>, una volta creata puoi selezionarla dal menu a tendina.",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "artwork": "Carica formati JPG, risoluzione solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data di pubblicazione originale per tutti i negozi a livello mondiale.",
                "official_release_date": "Data di pubblicazione ufficiale per tutti i negozi a livello mondiale.",
                "release_language": "In quale lingua è scritto il nome della pubblicazione? Controllalo due volte se non sei sicuro. Se questo input è errato, alcuni negozi come iTunes e Apple Music rifiuteranno la pubblicazione.",
                "ean": "Il Codice Universale del Prodotto o Numero dell'Articolo Europeo per la pubblicazione. I codici validi sono di 13 cifre. Se non ne hai uno tuo, ne genereremo uno per te."
            },
            "option": {
                "yes": "Sì",
                "no": "No",
                "no_exclusive": "Nessuna esclusiva",
                "beatport_2weeks": "Beatport 2 settimane",
                "beatport_4weeks": "Beatport 4 settimane",
                "preorder_1week": "Pre-ordine 1 settimana",
                "preorder_2weeks": "Pre-ordine 2 settimane",
                "traxsource_2weeks": "Traxsource 2 settimane",
                "select": "Seleziona...",
                "worldwide": "In tutto il mondo",
                "only_selected": "Solo paesi selezionati",
                "all_except_selected": "Tutti eccetto i paesi selezionati"
            },
            "message": {
                "track_name_required": "Per favore digita il nome della traccia",
                "mix_name_required": "Per favore digita il nome del mix",
                "mix_name_invalid": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore",
                "artist_required": "Per favore seleziona l'artista",
                "artist_type_required": "Per favore seleziona il tipo di artista",
                "catalog_duplicate": "Il numero di catalogo '{{number}}' è già stato usato. Inseriscine un altro.",
                "ean_duplicate": "Questo numero EAN è associato a un'altra uscita. Inserisci un altro.",
                "artist_added": "Nuovo Artista aggiunto!",
                "track_limit": "Il tuo limite attuale di tracce è insufficiente. Per favore aggiorna il tuo account o contatta il supporto.",
                "select_day": "Per favore seleziona un giorno.",
                "form_error": "Il modulo non può essere inviato! Per favore compila tutti i campi e controlla gli errori!",
                "ean_invalid": "Il valore non è un EAN valido. Se stai inserendo una nuova pubblicazione, lascia questo campo vuoto e genereremo un EAN per te. Se stai caricando un catalogo precedente e l'EAN non è valido, contattaci.",
                "ean_length": "Il numero EAN deve essere di 13 caratteri",
                "artwork_invalid": "Questo file non è valido, assicurati che l'immagine abbia estensione .jpg, colori RGB, dimensioni 3000 X 3000 e fino a 4MB.",
                "track_invalid": "Questo file non è valido, assicurati di codificare correttamente il tuo file in 16 bit, 44.1 Khz.",
                "artworkSwapTokenRequiredTooltip": "Il tuo saldo token attuale è insufficiente. È richiesto almeno 1 token per sostituire la copertina."
            },
            "button": {
                "reset": "Reimposta",
                "save_only": "Salva solo",
                "save_and_continue": "Salva e continua"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sei sicuro di voler ignorare le migliori pratiche per le date di pubblicazione?",
                    "body": "Nota che selezionando questa opzione, la tua data di pubblicazione potrebbe non essere accettata dai negozi o ingerita e pubblicata nella data selezionata. Inoltre, stai riducendo fortemente le opportunità di marketing.",
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma"
                    }
                },
                "release_created": {
                    "header": "Pubblicazione creata!",
                    "body": "La tua pubblicazione è stata creata con successo!",
                    "button": {
                        "close": "Chiudi"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Aggiorna Pubblicazione",
        "form": {
            "label": {
                "required": "Obbligatorio",
                "name": "Nome della Pubblicazione",
                "version": "Versione della Pubblicazione",
                "subuser": "Sotto-Utente",
                "label": "Etichetta",
                "copyright": "Copyright ©",
                "copyright_year": "Anno Copyright ©",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Anno Copyright ℗",
                "genre": "Genere",
                "subgenre": "Sotto-Genere",
                "catalog_number": "Numero di Catalogo",
                "artwork": "Copertina",
                "artwork_alt": "La tua copertina",
                "new_release": "È una nuova pubblicazione?",
                "original_release_date": "Data di pubblicazione originale",
                "official_release_date": "Data di pubblicazione ufficiale",
                "backcatalog": "Catalogo precedente",
                "assisted_dates": "Date assistite",
                "exclusive_store_release_date": "Data di pubblicazione esclusiva nei negozi",
                "additional_metadata": "Metadati aggiuntivi",
                "release_description": "Descrizione della Pubblicazione",
                "release_language": "Lingua del Nome della Pubblicazione",
                "auto_detect_language": "Rilevamento automatico (Lingua)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Genera automaticamente (ean)",
                "territories": "Territori",
                "countries": "Paesi",
                "youtube_declaration_header": "DICHIARAZIONE DI CONTENT ID DI YOUTUBE",
                "youtube_declaration_intro": "Per aderire al Content ID di YouTube per questa pubblicazione, devi assicurarti di soddisfare TUTTI i seguenti requisiti:",
                "youtube_declaration_certify": "Io, <strong>{{firstName}} {{lastName}}</strong>, sotto pena di spergiuro, certifico che le informazioni precedenti sono vere e corrette.",
                "youtube_declaration_point1": "Ho diritti sufficienti sul materiale.",
                "youtube_declaration_point2": "Tutti i contenuti di riferimento sono sufficientemente distintivi.",
                "youtube_declaration_point3": "Ho riferimenti individuali per ogni pezzo di proprietà intellettuale.",
                "youtube_declaration_point4": "Il contenuto consegnato <strong>non</strong> è nessuno dei seguenti: dominio pubblico, contenuto con licenza non esclusiva, clip da altre fonti utilizzate secondo i principi del fair use, filmati di gioco (da parte di editori diversi dal gioco), registrazioni karaoke, rimasterizzazioni senza permesso, registrazioni simili, contenuti doppiati, accelerazioni/rallentamenti, effetti sonori, basi sonore, mix DJ continui, mashup, liste di conto alla rovescia o qualsiasi altro contenuto proibito o non idoneo nominato nelle Linee Guida del Content ID di YouTube elencate di seguito.",
                "youtube_declaration_account": "Comprendo che il mio account potrebbe essere disattivato e terminato in caso di violazioni. Inoltre, comprendo pienamente che potrei essere responsabile di eventuali commissioni, danni, spese legali o qualsiasi altra spesa che possa accumularsi.",
                "youtube_declaration_guidelines": "Secondo le <1><strong>Linee Guida del Content ID di YouTube</strong></1>, il contenuto inviato tramite questa pubblicazione è completamente idoneo per il Content ID di YouTube.",
                "youtube_content_id_eligible": "Confermo che il mio contenuto è idoneo per il <strong>Content ID di YouTube</strong>",
                "youtube_content_id_not_eligible": "Il mio contenuto non è idoneo per il <strong>Content ID di YouTube</strong>",
                "immersive_audio": "Questa pubblicazione ha audio immersivo"
            },
            "placeholder": {
                "version": "Lascia vuoto se non sei sicuro o se questa è una pubblicazione regolare",
                "select_date": "Seleziona data...",
                "copyright": "Di solito il nome della tua etichetta",
                "copyright_publisher": "Di solito il nome della tua etichetta",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "label": "Seleziona Etichetta...",
                "subuser": "Seleziona Sotto-utente...",
                "genre": "Seleziona Genere...",
                "subgenre": "Seleziona Sotto-Genere...",
                "ean": "Lascia vuoto se non sei sicuro!",
                "release_description": "Qualche parola sulla tua pubblicazione. Nessun link e indirizzi e-mail per favore. Massimo 600 caratteri"
            },
            "help_text": {
                "name": "Per favore non usare aggiunte al nome della pubblicazione come LP e EP.",
                "version": "Alcune pubblicazioni vengono rilasciate in più di una versione, in tal caso inserisci il nome della versione. Se la tua pubblicazione è originale/standard ignora questo campo.",
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una pubblicazione per uno dei tuoi Sotto-utenti altrimenti lascia non selezionato.",
                "label": "Nota: Seleziona la tua Etichetta dal menu a tendina se esiste già nel sistema, altrimenti crea la tua Etichetta cliccando <1>qui</1>, una volta creata puoi selezionarla dal menu a tendina.",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "artwork": "Carica formati JPG, risoluzione solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data di pubblicazione originale per tutti i negozi a livello mondiale.",
                "official_release_date": "Data di pubblicazione ufficiale per tutti i negozi a livello mondiale.",
                "release_language": "In quale lingua è scritto il nome della pubblicazione? Controllalo due volte se non sei sicuro. Se questo input è errato, alcuni negozi come iTunes e Apple Music rifiuteranno la pubblicazione.",
                "ean": "Il Codice Universale del Prodotto o Numero dell'Articolo Europeo per la pubblicazione. I codici validi sono di 13 cifre. Se non ne hai uno tuo, ne genereremo uno per te."
            },
            "option": {
                "yes": "Sì",
                "no": "No",
                "no_exclusive": "Nessuna esclusiva",
                "beatport_2weeks": "Beatport 2 settimane",
                "beatport_4weeks": "Beatport 4 settimane",
                "preorder_1week": "Pre-ordine 1 settimana",
                "preorder_2weeks": "Pre-ordine 2 settimane",
                "traxsource_2weeks": "Traxsource 2 settimane",
                "select": "Seleziona...",
                "worldwide": "In tutto il mondo",
                "only_selected": "Solo paesi selezionati",
                "all_except_selected": "Tutti eccetto i paesi selezionati"
            },
            "message": {
                "track_name_required": "Per favore digita il nome della traccia",
                "mix_name_required": "Per favore digita il nome del mix",
                "mix_name_invalid": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore",
                "artist_required": "Per favore seleziona l'artista",
                "artist_type_required": "Per favore seleziona il tipo di artista",
                "catalog_duplicate": "Il numero di catalogo '{{number}}' è già stato usato. Inseriscine un altro.",
                "ean_duplicate": "Questo numero EAN è associato a un'altra uscita. Inserisci un altro.",
                "artist_added": "Nuovo Artista aggiunto!",
                "track_limit": "Il tuo limite attuale di tracce è {{trackLimit}} traccia(e). Per caricare più tracce, aggiorna il tuo account o contatta il nostro team di supporto.",
                "select_day": "Per favore seleziona un giorno.",
                "form_error": "Il modulo non può essere inviato! Per favore compila tutti i campi e controlla gli errori!",
                "ean_invalid": "Il valore non è un EAN valido. Se stai inserendo una nuova pubblicazione, lascia questo campo vuoto e genereremo un EAN per te. Se stai caricando un catalogo precedente e l'EAN non è valido, contattaci.",
                "ean_length": "Il numero EAN deve essere di 13 caratteri",
                "artwork_invalid": "Questo file non è valido, assicurati che l'immagine abbia estensione .jpg, colori RGB, dimensioni 3000 X 3000 e fino a 4MB.",
                "track_invalid": "Questo file non è valido, assicurati di codificare correttamente il tuo file in 16 bit, 44.1 Khz."
            },
            "button": {
                "reset": "Reimposta",
                "submit_form": "Invia Modulo",
                "save_and_continue": "Salva e continua"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sei sicuro di voler ignorare le migliori pratiche per le date di pubblicazione?",
                    "body": "Nota che selezionando questa opzione, la tua data di pubblicazione potrebbe non essere accettata dai negozi o ingerita e pubblicata nella data selezionata. Inoltre, stai riducendo fortemente le opportunità di marketing.",
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma"
                    }
                },
                "release_updated": {
                    "header": "Pubblicazione aggiornata!",
                    "body": "La tua pubblicazione è stata aggiornata con successo!",
                    "button": {
                        "close": "Chiudi"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Trasferisci Pubblicazione",
        "view": {
            "title": "Trasferisci Pubblicazione",
            "label": {
                "searchBy": "Cerca Per",
                "upc": "Numero UPC",
                "url": "URL Pubblicazione Negozio",
                "name": "Nome della Pubblicazione",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Recupero Dettagli Pubblicazione..."
            },
            "placeholder": {
                "upc": "Inserisci Numero UPC/EAN della Pubblicazione es. 5055964352523",
                "url": "Inserisci URL Pubblicazione Negozio es. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn o www.deezer.com/en/album/413370367",
                "name": "Inserisci Nome della Pubblicazione es. Warrior"
            },
            "help_text": {
                "upc": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una Pubblicazione che è già su Spotify o Deezer.",
                "url": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una Pubblicazione che è già su Spotify o Deezer.",
                "name_spotify": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una Pubblicazione che è già su Spotify.",
                "name_deezer": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una Pubblicazione che è già su Deezer."
            },
            "button": {
                "reset": "Reimposta",
                "transfer": "Trasferisci"
            },
            "message": {
                "release_exists": "Una pubblicazione con questo numero UPC appartiene già a un altro utente all'interno della piattaforma Music Link. Importa solo pubblicazioni che appartengono interamente alla tua azienda e etichetta. Se credi che qualcuno abbia preso la tua pubblicazione senza permesso, contatta il nostro team di supporto."
            }
        },
        "modal": {
            "header": "Termini di Trasferimento della Pubblicazione",
            "ownership_warranty": {
                "header": "Garanzia di Proprietà",
                "body": {
                    "point1": "Accettando questi termini, riconosci e garantisci di avere la proprietà legale o rappresenti il legittimo proprietario di tutti i contenuti, inclusa la pubblicazione e le canzoni associate, forniti qui.",
                    "point2": "Affermi che nessun materiale protetto da copyright o proprietà intellettuale appartenente a terzi è incorporato in questa pubblicazione."
                }
            },
            "non_infringement_warranty": {
                "header": "Garanzia di Non Violazione",
                "body": {
                    "point1": "Procedendo, confermi espressamente che il contenuto inviato in questa pubblicazione non viola alcun diritto di terzi, inclusi ma non limitati a copyright, marchio o qualsiasi altro diritto proprietario.",
                    "point2": "Accetti di non includere materiale da fonti esterne senza la dovuta autorizzazione."
                }
            },
            "exclusivity_declaration": {
                "header": "Dichiarazione di Esclusività",
                "body": {
                    "point1": "Acconsentendo a questi termini, dichiari che il contenuto presentato in questa pubblicazione è esclusivo della tua proprietà o rappresentanza autorizzata, e non è stato offerto o rilasciato a nessun'altra entità o piattaforma.",
                    "point2": "Ti assumi la piena responsabilità per qualsiasi violazione dell'esclusività e comprendi che tale violazione può comportare conseguenze legali."
                }
            },
            "legal_consequences_awareness": {
                "header": "Consapevolezza delle Conseguenze Legali",
                "body": {
                    "point1": "È fondamentale comprendere che qualsiasi violazione dei termini e delle garanzie delineati in questo modulo o termini può comportare gravi conseguenze legali.",
                    "point2": "Queste penalità potrebbero includere, ma non sono limitate a, sostanziali responsabilità finanziarie, ingiunzioni legali e danni alla reputazione.",
                    "point3": "Accettando questi termini, riconosci la serietà di rispettare gli obblighi dichiarati e riconosci che la non conformità può comportare azioni legali contro di te o la tua organizzazione."
                }
            },
            "button": {
                "cancel": "Annulla",
                "agree": "Accetto"
            }
        },
        "form": {
            "title": "Trasferisci Pubblicazione",
            "label": {
                "required": "Obbligatorio",
                "name": "Nome della Pubblicazione",
                "version": "Versione della Pubblicazione",
                "subuser": "Sotto-Utente",
                "label": "Etichetta",
                "copyright": "Copyright ©",
                "copyright_year": "Anno Copyright ©",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Anno Copyright ℗",
                "genre": "Genere",
                "subgenre": "Sotto-Genere",
                "catalog_number": "Numero di Catalogo",
                "artwork": "Copertina",
                "artwork_alt": "La tua copertina",
                "new_release": "È una nuova pubblicazione?",
                "original_release_date": "Data di pubblicazione originale",
                "official_release_date": "Data di pubblicazione ufficiale",
                "backcatalog": "Catalogo precedente",
                "assisted_dates": "Date assistite",
                "exclusive_store_release_date": "Data di pubblicazione esclusiva nei negozi",
                "additional_metadata": "Metadati aggiuntivi",
                "release_description": "Descrizione della Pubblicazione",
                "release_language": "Lingua del Nome della Pubblicazione",
                "auto_detect_language": "Rilevamento automatico (Lingua)",
                "ean": "EAN / UPC",
                "territories": "Territori",
                "countries": "Paesi",
                "youtube_declaration_header": "DICHIARAZIONE DI CONTENT ID DI YOUTUBE",
                "youtube_declaration_intro": "Per aderire al Content ID di YouTube per questa pubblicazione, devi assicurarti di soddisfare TUTTI i seguenti requisiti:",
                "youtube_declaration_certify": "Io, <strong>{{firstName}} {{lastName}}</strong>, sotto pena di spergiuro, certifico che le informazioni precedenti sono vere e corrette.",
                "youtube_declaration_point1": "Ho diritti sufficienti sul materiale.",
                "youtube_declaration_point2": "Tutti i contenuti di riferimento sono sufficientemente distintivi.",
                "youtube_declaration_point3": "Ho riferimenti individuali per ogni pezzo di proprietà intellettuale.",
                "youtube_declaration_point4": "Il contenuto consegnato <strong>non</strong> è nessuno dei seguenti: dominio pubblico, contenuto con licenza non esclusiva, clip da altre fonti utilizzate secondo i principi del fair use, filmati di gioco (da parte di editori diversi dal gioco), registrazioni karaoke, rimasterizzazioni senza permesso, registrazioni simili, contenuti doppiati, accelerazioni/rallentamenti, effetti sonori, basi sonore, mix DJ continui, mashup, liste di conto alla rovescia o qualsiasi altro contenuto proibito o non idoneo nominato nelle Linee Guida del Content ID di YouTube elencate di seguito.",
                "youtube_declaration_account": "Comprendo che il mio account potrebbe essere disattivato e terminato in caso di violazioni. Inoltre, comprendo pienamente che potrei essere responsabile di eventuali commissioni, danni, spese legali o qualsiasi altra spesa che possa accumularsi.",
                "youtube_declaration_guidelines": "Secondo le <1><strong>Linee Guida del Content ID di YouTube</strong></1>, il contenuto inviato tramite questa pubblicazione è completamente idoneo per il Content ID di YouTube.",
                "youtube_content_id_eligible": "Confermo che il mio contenuto è idoneo per il <strong>Content ID di YouTube</strong>",
                "youtube_content_id_not_eligible": "Il mio contenuto non è idoneo per il <strong>Content ID di YouTube</strong>",
                "immersive_audio": "Questa pubblicazione ha audio immersivo"
            },
            "placeholder": {
                "version": "Lascia vuoto se non sei sicuro o se questa è una pubblicazione regolare",
                "select_date": "Seleziona data...",
                "copyright": "Di solito il nome della tua etichetta",
                "copyright_publisher": "Di solito il nome della tua etichetta",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "label": "Seleziona Etichetta...",
                "subuser": "Seleziona Sotto-utente...",
                "genre": "Seleziona Genere...",
                "subgenre": "Seleziona Sotto-Genere...",
                "ean": "Lascia vuoto se non sei sicuro!",
                "release_description": "Qualche parola sulla tua pubblicazione. Nessun link e indirizzi e-mail per favore. Massimo 600 caratteri"
            },
            "help_text": {
                "name": "Per favore non usare aggiunte al nome della pubblicazione come LP e EP.",
                "version": "Alcune pubblicazioni vengono rilasciate in più di una versione, in tal caso inserisci il nome della versione. Se la tua pubblicazione è originale/standard ignora questo campo.",
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una pubblicazione per uno dei tuoi Sotto-utenti altrimenti lascia non selezionato.",
                "label": "Nota: Seleziona la tua Etichetta <strong>{{labelName}}</strong> dal menu a tendina se esiste già nel sistema, altrimenti crea la tua Etichetta <strong>{{labelName}}</strong> cliccando <5>qui</5>, una volta creata puoi selezionarla dal menu a tendina.",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "artwork": "Carica formati JPG, risoluzione solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data di pubblicazione originale per tutti i negozi a livello mondiale.",
                "official_release_date": "Data di pubblicazione ufficiale per tutti i negozi a livello mondiale.",
                "release_language": "In quale lingua è scritto il nome della pubblicazione? Controllalo due volte se non sei sicuro. Se questo input è errato, alcuni negozi come iTunes e Apple Music rifiuteranno la pubblicazione.",
                "ean": "Il Codice Universale del Prodotto o Numero dell'Articolo Europeo per la pubblicazione. I codici validi sono di 13 cifre. Se non ne hai uno tuo, ne genereremo uno per te."
            },
            "option": {
                "yes": "Sì",
                "no": "No",
                "no_exclusive": "Nessuna esclusiva",
                "beatport_2weeks": "Beatport 2 settimane",
                "beatport_4weeks": "Beatport 4 settimane",
                "preorder_1week": "Pre-ordine 1 settimana",
                "preorder_2weeks": "Pre-ordine 2 settimane",
                "traxsource_2weeks": "Traxsource 2 settimane",
                "select": "Seleziona...",
                "worldwide": "In tutto il mondo",
                "only_selected": "Solo paesi selezionati",
                "all_except_selected": "Tutti eccetto i paesi selezionati"
            },
            "message": {
                "track_name_required": "Per favore digita il nome della traccia",
                "mix_name_required": "Per favore digita il nome del mix",
                "mix_name_invalid": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore",
                "artist_required": "Per favore seleziona l'artista",
                "artist_type_required": "Per favore seleziona il tipo di artista",
                "catalog_duplicate": "Il numero di catalogo '{{number}}' è già stato usato. Inseriscine un altro.",
                "artist_added": "Nuovo Artista aggiunto!",
                "track_limit": "Il tuo limite attuale di tracce è {{trackLimit}} traccia(e). Per caricare più tracce, aggiorna il tuo account o contatta il nostro team di supporto.",
                "select_day": "Per favore seleziona un giorno.",
                "form_error": "Il modulo non può essere inviato! Per favore compila tutti i campi e controlla gli errori!",
                "ean_invalid": "Il valore non è un EAN valido. Se stai inserendo una nuova pubblicazione, lascia questo campo vuoto e genereremo un EAN per te. Se stai caricando un catalogo precedente e l'EAN non è valido, contattaci.",
                "ean_length": "Il numero EAN deve essere di 13 caratteri",
                "artwork_invalid": "Questo file non è valido, assicurati che l'immagine abbia estensione .jpg, colori RGB, dimensioni 3000 X 3000 e fino a 4MB.",
                "track_invalid": "Questo file non è valido, assicurati di codificare correttamente il tuo file in 16 bit, 44.1 Khz."
            },
            "button": {
                "reset": "Reimposta",
                "save_only": "Salva solo",
                "save_and_continue": "Salva e continua"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sei sicuro di voler ignorare le migliori pratiche per le date di pubblicazione?",
                    "body": "Nota che selezionando questa opzione, la tua data di pubblicazione potrebbe non essere accettata dai negozi o ingerita e pubblicata nella data selezionata. Inoltre, stai riducendo fortemente le opportunità di marketing.",
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma"
                    }
                },
                "release_created": {
                    "header": "Pubblicazione creata!",
                    "body": "La tua pubblicazione è stata creata con successo!",
                    "button": {
                        "close": "Chiudi"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Dichiarazione di Trasferimento della Pubblicazione",
                    "body": "Ho controllato e completato tutte le informazioni necessarie per questa pubblicazione ed è ora pronta per il CARICAMENTO.",
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Visualizza Pubblicazione",
        "form": {
            "label": {
                "required": "Obbligatorio",
                "name": "Nome della Pubblicazione",
                "version": "Versione della Pubblicazione",
                "subuser": "Sotto-Utente",
                "label": "Etichetta",
                "copyright": "Copyright ©",
                "copyright_year": "Anno Copyright ©",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Anno Copyright ℗",
                "genre": "Genere",
                "subgenre": "Sotto-Genere",
                "catalog_number": "Numero di Catalogo",
                "artwork": "Copertina",
                "artwork_alt": "La tua copertina",
                "new_release": "È una nuova pubblicazione?",
                "original_release_date": "Data di pubblicazione originale",
                "official_release_date": "Data di pubblicazione ufficiale",
                "backcatalog": "Catalogo precedente",
                "assisted_dates": "Date assistite",
                "exclusive_store_release_date": "Data di pubblicazione esclusiva nei negozi",
                "additional_metadata": "Metadati aggiuntivi",
                "release_description": "Descrizione della Pubblicazione",
                "release_language": "Lingua del Nome della Pubblicazione",
                "auto_detect_language": "Rilevamento automatico (Lingua)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Genera automaticamente (ean)",
                "territories": "Territori",
                "countries": "Paesi",
                "youtube_declaration_header": "DICHIARAZIONE DI CONTENT ID DI YOUTUBE",
                "youtube_declaration_intro": "Per aderire al Content ID di YouTube per questa pubblicazione, devi assicurarti di soddisfare TUTTI i seguenti requisiti:",
                "youtube_declaration_certify": "Io, <strong>{{firstName}} {{lastName}}</strong>, sotto pena di spergiuro, certifico che le informazioni precedenti sono vere e corrette.",
                "youtube_declaration_point1": "Ho diritti sufficienti sul materiale.",
                "youtube_declaration_point2": "Tutti i contenuti di riferimento sono sufficientemente distintivi.",
                "youtube_declaration_point3": "Ho riferimenti individuali per ogni pezzo di proprietà intellettuale.",
                "youtube_declaration_point4": "Il contenuto consegnato <strong>non</strong> è nessuno dei seguenti: dominio pubblico, contenuto con licenza non esclusiva, clip da altre fonti utilizzate secondo i principi del fair use, filmati di gioco (da parte di editori diversi dal gioco), registrazioni karaoke, rimasterizzazioni senza permesso, registrazioni simili, contenuti doppiati, accelerazioni/rallentamenti, effetti sonori, basi sonore, mix DJ continui, mashup, liste di conto alla rovescia o qualsiasi altro contenuto proibito o non idoneo nominato nelle Linee Guida del Content ID di YouTube elencate di seguito.",
                "youtube_declaration_account": "Comprendo che il mio account potrebbe essere disattivato e terminato in caso di violazioni. Inoltre, comprendo pienamente che potrei essere responsabile di eventuali commissioni, danni, spese legali o qualsiasi altra spesa che possa accumularsi.",
                "youtube_declaration_guidelines": "Secondo le <1><strong>Linee Guida del Content ID di YouTube</strong></1>, il contenuto inviato tramite questa pubblicazione è completamente idoneo per il Content ID di YouTube.",
                "youtube_content_id_eligible": "Confermo che il mio contenuto è idoneo per il <strong>Content ID di YouTube</strong>",
                "youtube_content_id_not_eligible": "Il mio contenuto non è idoneo per il <strong>Content ID di YouTube</strong>",
                "immersive_audio": "Questa pubblicazione ha audio immersivo"
            },
            "placeholder": {
                "version": "Lascia vuoto se non sei sicuro o se questa è una pubblicazione regolare",
                "select_date": "Seleziona data...",
                "copyright": "Di solito il nome della tua etichetta",
                "copyright_publisher": "Di solito il nome della tua etichetta",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "label": "Seleziona Etichetta...",
                "subuser": "Seleziona Sotto-utente...",
                "artist": "Seleziona Artista...",
                "genre": "Seleziona Genere...",
                "subgenre": "Seleziona Sotto-Genere...",
                "ean": "Lascia vuoto se non sei sicuro!",
                "release_description": "Qualche parola sulla tua pubblicazione. Nessun link e indirizzi e-mail per favore. Massimo 600 caratteri"
            },
            "help_text": {
                "name": "Per favore non usare aggiunte al nome della pubblicazione come LP e EP.",
                "version": "Alcune pubblicazioni vengono rilasciate in più di una versione, in tal caso inserisci il nome della versione. Se la tua pubblicazione è originale/standard ignora questo campo.",
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere una pubblicazione per uno dei tuoi Sotto-utenti altrimenti lascia non selezionato.",
                "catalog_number": "Inserisci il tuo numero di catalogo. Di solito le etichette inseriscono l'abbreviazione del nome dell'etichetta e un numero. Es. {{prefix}}001, {{prefix}}002...",
                "artwork": "Carica formati JPG, risoluzione solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data di pubblicazione originale per tutti i negozi a livello mondiale.",
                "official_release_date": "Data di pubblicazione ufficiale per tutti i negozi a livello mondiale.",
                "release_language": "In quale lingua è scritto il nome della pubblicazione? Controllalo due volte se non sei sicuro. Se questo input è errato, alcuni negozi come iTunes e Apple Music rifiuteranno la pubblicazione.",
                "ean": "Il Codice Universale del Prodotto o Numero dell'Articolo Europeo per la pubblicazione. I codici validi sono di 13 cifre. Se non ne hai uno tuo, ne genereremo uno per te."
            },
            "option": {
                "yes": "Sì",
                "no": "No",
                "no_exclusive": "Nessuna esclusiva",
                "beatport_2weeks": "Beatport 2 settimane",
                "beatport_4weeks": "Beatport 4 settimane",
                "preorder_1week": "Pre-ordine 1 settimana",
                "preorder_2weeks": "Pre-ordine 2 settimane",
                "traxsource_2weeks": "Traxsource 2 settimane",
                "select": "Seleziona...",
                "worldwide": "In tutto il mondo",
                "only_selected": "Solo paesi selezionati",
                "all_except_selected": "Tutti eccetto i paesi selezionati"
            },
            "message": {
                "track_name_required": "Per favore digita il nome della traccia",
                "mix_name_required": "Per favore digita il nome del mix",
                "mix_name_invalid": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore",
                "artist_required": "Per favore seleziona l'artista",
                "artist_type_required": "Per favore seleziona il tipo di artista",
                "catalog_duplicate": "Il numero di catalogo '{{number}}' è già stato usato. Inseriscine un altro.",
                "artist_added": "Nuovo Artista aggiunto!",
                "track_limit": "Il tuo limite attuale di tracce è {{trackLimit}} traccia(e). Per caricare più tracce, aggiorna il tuo account o contatta il nostro team di supporto.",
                "select_day": "Per favore seleziona un giorno.",
                "form_error": "Il modulo non può essere inviato! Per favore compila tutti i campi e controlla gli errori!",
                "ean_invalid": "Il valore non è un EAN valido. Se stai inserendo una nuova pubblicazione, lascia questo campo vuoto e genereremo un EAN per te. Se stai caricando un catalogo precedente e l'EAN non è valido, contattaci.",
                "ean_length": "Il numero EAN deve essere di 13 caratteri",
                "artwork_invalid": "Questo file non è valido, assicurati che l'immagine abbia estensione .jpg, colori RGB, dimensioni 3000 X 3000 e fino a 4MB.",
                "track_invalid": "Questo file non è valido, assicurati di codificare correttamente il tuo file in 16 bit, 44.1 Khz."
            },
            "button": {
                "submit": "Invia Modulo"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sei sicuro di voler ignorare le migliori pratiche per le date di pubblicazione?",
                    "body": "Nota che selezionando questa opzione, la tua data di pubblicazione potrebbe non essere accettata dai negozi o ingerita e pubblicata nella data selezionata. Inoltre, stai riducendo fortemente le opportunità di marketing.",
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma"
                    }
                },
                "release_updated": {
                    "header": "Pubblicazione aggiornata!",
                    "body": "La tua pubblicazione è stata aggiornata con successo!",
                    "button": {
                        "close": "Chiudi"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Artista Principale",
            "featuring": "Artista Ospite",
            "remixer": "Remixer"
        },
        "placeholder": {
            "selectArtist": "Seleziona Artista..."
        },
        "button": {
            "remove": "Rimuovi",
            "addAnother": "Aggiungi un altro",
            "createNew": "Creare nuovo?"
        },
        "modal": {
            "header": "Sei sicuro di voler assegnare questo artista come Artista Ospite?",
            "body": "Per favore non confondere l'Artista Ospite con un Remixer. L'Artista Ospite dovrebbe essere aggiunto solo se sei sicuro che questo artista non è l'Artista Principale o un Remixer.",
            "cancel": "Annulla",
            "confirm": "Conferma"
        },
        "label": {
            "order": "Ordine",
            "artistName": "Nome dell'artista",
            "artistType": "Tipo di artista",
            "artists": "Artisti",
            "required": "Obbligatorio"
        },
        "help_text": {
            "artists": "Se la pubblicazione è scritta da più di <strong>4 Artisti Principali</strong> usa <strong>Vari Artisti</strong>. Gli artisti delle tracce, i remixers e i contributori dovrebbero essere aggiunti nella fase di Modifica Traccia."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Tracce",
            "order": "Ordine",
            "trackName": "Nome della traccia",
            "mixName": "Nome del mix",
            "file": "File",
            "albumOnly": "Solo Album",
            "required": "Obbligatorio",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Aggiungi un altro",
            "remove": "Rimuovere?",
            "onlyAlbum": "Solo Album",
            "mixTypes": {
                "originalMix": "Mix Originale",
                "remixOrMix": "Questo è un Remix o Mix"
            }
        },
        "button": {
            "remove": "Rimuovi",
            "addAnother": "Aggiungi un altro"
        },
        "validation": {
            "trackName": "Per favore digita il nome della traccia",
            "mixName": "Per favore digita il nome del mix",
            "mixNameRegex": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore",
            "trackFile": "Per favore seleziona il file della traccia",
            "trackFileDolby": "Per favore seleziona il file dolby atmos della traccia",
            "trackFileDuration": "La durata dei file delle tracce Stereo e Dolby deve corrispondere",
            "swapTrackAudioTokenRequiredTooltip": "Il tuo saldo token attuale è insufficiente. È richiesto almeno 1 token per sostituire l'audio della traccia."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Artisti",
            "order": "Ordine",
            "artistName": "Nome dell'artista",
            "artistType": "Tipo di artista",
            "required": "Obbligatorio"
        },
        "placeholder": {
            "selectArtist": "Seleziona Artista..."
        },
        "help_text": {
            "artists": "Se la pubblicazione è scritta da più di <strong>4 Artisti Principali</strong> usa <strong>Vari Artisti</strong>. Gli artisti delle tracce, i remixers e i contributori dovrebbero essere aggiunti nella fase di Modifica Traccia."
        },
        "option": {
            "artistType": {
                "main": "Artista Principale",
                "featuring": "Artista Ospite",
                "remixer": "Remixer"
            }
        },
        "button": {
            "remove": "Rimuovi",
            "addAnother": "Aggiungi un altro",
            "createNew": "Creare nuovo?"
        },
        "message": {
            "errorArtistRequired": "Per favore seleziona l'artista",
            "errorArtistTypeRequired": "Per favore seleziona il tipo di artista"
        },
        "modal": {
            "header": "Sei sicuro di voler assegnare questo artista come Artista Ospite?",
            "body": "Per favore non confondere l'Artista Ospite con un Remixer. L'Artista Ospite dovrebbe essere aggiunto solo se sei sicuro che questo artista non è l'Artista Principale o un Remixer.",
            "button": {
                "cancel": "Annulla",
                "confirm": "Conferma"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Store"
        },
        "placeholder": {
            "search": "Cerca store..."
        },
        "section": {
            "mandatory": "Obbligatorio",
            "optional": "Opzionale",
            "optional_locked": "Opzionale Store Aggiuntivi",
            "summary": {
                "read_only": "{{title}} ({{count}} totali)",
                "editable": "{{title}} ({{total}} totali, {{selected}} selezionati)"
            }
        },
        "message": {
            "no_stores": "Nessuno store trovato.",
            "availability": "Beatport è disponibile solo per le release Dance con etichette approvate da Beatport. Traxsource è disponibile solo per le release Dance con etichette approvate da Traxsource.",
            "youtube_declaration": "Per favore firma prima la dichiarazione YouTube Content ID.",
            "youtube_ineligible": "Questo store non è idoneo poiché hai dichiarato di non avere i diritti di proprietà. Se dichiarato falsamente, potresti essere ritenuto responsabile in una controversia legale.",
            "youtube_content_id": "Questo store non è applicabile alle release idonee per YouTube Content ID perché viene consegnato sia a YouTube Content ID sia a YouTube Premium.",
            "beatport": "Beatport può essere selezionato solo quando il genere è Dance e l'etichetta è approvata per Beatport.",
            "traxsource": "Traxsource può essere selezionato solo quando il genere è Dance e l'etichetta è approvata per Traxsource.",
            "juno": "JunoDownload può essere selezionato solo quando il genere è Dance.",
            "contact_support": "Contatta il nostro team di supporto per sbloccare questi store.",
            "optional_additional_none_selected": "Non hai selezionato alcuno Store Aggiuntivo Opzionale. Questi possono ampliare la tua portata. Sei sicuro di volerli saltare?",
            "optional_paid_insufficient_tokens": "Saldo token insufficiente. È richiesto almeno 1 token per selezionare gli Store Aggiuntivi Opzionali.",
            "optional_paid_insufficient_tokens_with_link": "Il tuo saldo token attuale è insufficiente. È richiesto almeno 1 token per selezionare gli Store Aggiuntivi Opzionali. <2>Ordina token</2> per continuare."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Tracce",
            "order": "Ordine",
            "trackName": "Nome della traccia",
            "mixName": "Nome del mix",
            "file": "File",
            "albumOnly": "Solo Album",
            "required": "Obbligatorio",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Aggiungi un altro",
            "remove": "Rimuovere?",
            "onlyAlbum": "Solo Album",
            "mixTypes": {
                "originalMix": "Mix Originale",
                "remixOrMix": "Questo è un Remix o Mix"
            }
        },
        "button": {
            "remove": "Rimuovi",
            "addAnother": "Aggiungi un altro"
        },
        "validation": {
            "trackName": "Per favore digita il nome della traccia",
            "mixName": "Per favore digita il nome del mix",
            "mixNameRegex": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore",
            "trackFile": "Per favore seleziona il file della traccia",
            "trackFileDolby": "Per favore seleziona il file dolby atmos della traccia",
            "trackFileDuration": "La durata dei file delle tracce Stereo e Dolby deve corrispondere"
        }
    }
};

export default releasesIT;